// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"f9f53dba","59":"67e74a9e","329":"57d25a22","496":"e9d4657d","498":"2765f57e","513":"1aab9544","651":"3fa8044d","669":"1e5a0b4e","716":"373050e3","894":"3ebcadd5","898":"10c05dff"}[chunkId] + ".chunk.js";
};